
export function onedriveError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.status = payload.status
    state.jwt = ''
    state.access = false
    state.id = null
    
   
}
export function setVars(state, payload){
    state.jwt = payload.data.jwt
    state.msg =  payload.msg
    state.access = payload.data.access
    state.id = payload.data.id
}
export function clearJWT(state,payload){
    state.jwt = ''
    state.secret = ''
    state.msg =  ''
    state.access = false
}